import * as libLocation from "./lib/location.ts";
import "./pageset_nc.ts";
import "./features/login.ts";
import "./global.ts";
import "./lib/lottie/lottie-player.js";

try{
  //DO NOT change != by !=== the != is needed on old version of IE
  /*jslint eqeq:true*/
  if(window.parent && window.parent!=window){
    window.parent.location = window.location;
  }
}catch(e){
  console.error(e);
}
libLocation.init();


